import React, { useState, useEffect } from "react";
import { FaFileInvoice, FaUsers, FaSlideshare, FaSitemap, FaClipboardList, FaClipboard, FaBell } from "react-icons/fa";
import { GrProjects } from "react-icons/gr";
import { MdSpaceDashboard, MdPeople, MdAssignmentTurnedIn, MdGroups, MdWork } from "react-icons/md";
import SalesInvoiceImg from '../Assets/Images/Sidebar/sale.svg'
import HolidayImageIcon from '../Assets/Images/Sidebar/holidayIcon.svg'
import LeaveImageIcon from '../Assets/Images/Sidebar/LeaveIcon.svg'
import PurchaseInvoiceImg from '../Assets/Images/Sidebar/Purchase.svg'
import Attandance from '../Assets/Images/Sidebar/Frame.svg'
import { GiExpense, GiPalmTree, GiFireworkRocket } from "react-icons/gi";
import { AiOutlineClockCircle, AiOutlineFileDone, AiOutlineTransaction } from "react-icons/ai";
import { FaChevronRight } from "react-icons/fa";
import { FaChevronDown } from "react-icons/fa";
import { TbMessages, TbReportSearch } from "react-icons/tb";
import "../Assets/Css/Sidebar.scss";
import { Link, useLocation } from "react-router-dom";
import { collection, onSnapshot, query, where } from "firebase/firestore";
import { db } from "../Lib/Init-firebase";
import { Dashboard } from "../Lib/constants";
import ModulesList from "../Assets/ModulesLiist";
import RoleWiseModulWrapper from "../Lib/RoleWiseModulWrapper";
import AppreciationIcon from "../Assets/Images/Sidebar/AppreciationIcon.svg"
import DepartmentIcon from "../Assets/Images/Sidebar/Department.svg"
import DesignationIcon from "../Assets/Images/Sidebar/DesignationIcon.svg"
import ProjectIcon from "./../Assets/Images/Sidebar/project.svg"
import SettingIcon from "./../Assets/Images/Sidebar/setting.svg"
import Ticket from "../Assets/Images/Sidebar/Ticket.svg"
import TaskIcon from '../Assets/Images/Sidebar/taskicon.svg';
import TimeSheet from "../Assets/Images/Sidebar/TimeSheet.svg"
import NoticeBoard from "../Assets/Images/Notice/Notice.svg";
import { IoMdDocument } from "react-icons/io";
import { GiTakeMyMoney } from "react-icons/gi";
import { GiExitDoor } from "react-icons/gi";
import { HiMiniAdjustmentsVertical } from "react-icons/hi2";
import { SlEarphonesAlt } from "react-icons/sl";
import { FaBottleWater, FaHandsClapping } from "react-icons/fa6";
import { IoSettingsSharp } from "react-icons/io5";
import { PiUsersFill } from "react-icons/pi";

const Sidebar = ({ menuCollapse, menuIconClick, user, modules, features }) => {
  const [message, setMessage] = useState([]);
  const [dropdownOpen, setDropdownOpen] = useState({
    report: false,
    hr: false,
    work: false,
    invoices: false
  });
  const [employeesDropdownOpen, setEmployeesDropdownOpen] = useState(false);
  const [hovered, setHovered] = useState(false);

  // const data = modules?.filter((item) => {
  //   return user?.role?.permissions_role?.find((item2) => {
  //     return item2?.module_id === item.id;
  //   });
  // });

  // const data2 = data?.find ((item)=>{
  //   return item?.frontend_module_name == ModulesList?.Dashboard
  // })?.frontend_module_name
  const location = useLocation();
  let path = window.location.pathname;
  const myArray = path.split('/');
  let result = myArray[1];
  let result2 = myArray[2];
  const roleName = user?.role?.name;
  console.log(roleName, "<== roleName");
  const toggleDropdown = (key) => {
    setDropdownOpen((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };


  useEffect(() => {
    const messageCollectionRef = collection(db, 'users');
    const unViewMessage = onSnapshot(messageCollectionRef, (snapshot) => {
      setMessage(
        snapshot.docs.map((doc) => ({
          id: doc.id,
        }))
      );
    });
    return () => {
      unViewMessage();
    };
  }, []);

  return (
    <>
      <div className={`side ${menuCollapse ? 'side-closed side-bar' : 'show-sidebar'}`}>
        <div className="items">
          <div className="ed">
            <div className="part-1">
              {menuCollapse ? (
                <img
                  src={require('../Assets/Images/Sidebar/companylogo.png')}
                  width="40"
                  alt="closedigit"
                />
              ) : (
                <img
                  src={require('../Assets/Images/Sidebar/Group.png')}
                  width="230"
                  alt="closedigit"
                />
              )}
            </div>
          </div>
          <div className={`${menuCollapse ? 'part-2-closed' : 'part-2'}`}>
            <ul className={`${menuCollapse ? 'ul-closed' : ''}`}>
              <RoleWiseModulWrapper
                user={user}
                modules={modules}
                features={features}
                module={ModulesList?.Dashboard}
              >
                <Link to="/employee/dashboard" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                  <li className={`${menuCollapse ? 'ind-item-closed' : 'ind-item'} ${result2 ? result2 === 'dashboard' ? 'active-block' : '' : ''}`}>
                    <div className={`${menuCollapse ? 'i-closed' : 'i'}`}>
                      <div className="padder">
                        <MdSpaceDashboard className="icon-size" />
                        <span className="tooltip">Dashboard</span>
                      </div>
                      {menuCollapse ? null : (
                        <div className="family">
                          <span className="spa">Dashboard</span>
                        </div>
                      )}
                    </div>
                  </li>
                </Link>
              </RoleWiseModulWrapper>

              <RoleWiseModulWrapper
                user={user}
                modules={modules}
                features={features}
                module={ModulesList?.HR}
              >
                <Link to="#" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                  <li
                    style={{
                      listStyle: 'none',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: menuCollapse ? 'center' : 'space-between',
                    }}
                    className={`${menuCollapse ? 'ind-item-closed' : 'ind-item'} ${(result === 'employees' || result === 'leave' || result == "attendance" || result == "holiday" || result == 'specialday' || result == "appreciation" || result == "award")
                      ? 'active-block'
                      : ''
                      }`}
                    onClick={() => toggleDropdown('hr')}
                  >
                    <div className={`${menuCollapse ? 'i-closed' : 'i'}`}>
                      <div className="padder">
                        {' '}
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <PiUsersFill className="icon-size" />
                          {menuCollapse ? (
                            dropdownOpen.hr
                          ) : (
                            <></>
                          )}
                        </div>
                        <span className="tooltip">HR</span>
                      </div>
                      {menuCollapse ? (
                        dropdownOpen.hr
                      ) : (
                        <div
                          className="family"
                          style={{
                            display: 'flex',
                            width: '100%',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                          }}
                        >
                          <span className="spa">HR</span>
                          {dropdownOpen.hr ? (
                            <FaChevronDown className="arrow-icon" style={{ marginLeft: '4px' }} />
                          ) : (
                            <FaChevronRight className="arrow-icon" style={{ marginLeft: '4px' }} />
                          )}
                        </div>
                      )}
                    </div>
                  </li>
                </Link>
              </RoleWiseModulWrapper>
              {dropdownOpen.hr ? (
                <div className={`${menuCollapse ? 'collapsed-group' : ''}`} >
                  <ul className="sub-nav">
                    <RoleWiseModulWrapper
                      user={user}
                      modules={modules}
                      features={features}
                      module={ModulesList?.Employees}
                    >
                      <Link to="/employees" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                        <li
                          className={`${menuCollapse ? 'ind-item-closed' : 'ind-item'} ${result === 'employees' ? '' : ''
                            }`}
                          onMouseEnter={() => setHovered(true)}
                          onMouseLeave={() => setHovered(false)}
                          onClick={() => setEmployeesDropdownOpen(!employeesDropdownOpen)}
                        >
                          <div className={`${menuCollapse ? 'i-closed' : 'i'}`}>
                            {menuCollapse ? (
                              <div className="padder">
                                <FaUsers className="icon-size" />
                                <span className="tooltip">Employees</span>
                              </div>
                              // <></>
                            ) : (
                              <div
                                className="family"
                                style={{
                                  marginLeft: '20px'
                                }}
                              >
                                <div className="bullet" style={{ backgroundColor: result == "employees" ? "#5757fe" : "gray" }}
                                ></div>
                                <span className="spa" style={{ marginLeft: '10px', color: result == "employees" ? "#5757fe" : "gray" }}>Employees</span>
                              </div>
                            )}
                          </div>
                        </li>
                      </Link>
                    </RoleWiseModulWrapper>

                    <RoleWiseModulWrapper
                      user={user}
                      modules={modules}
                      features={features}
                      module={ModulesList?.Leaves}
                    >
                      <Link to="/leave/empleave" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                        <li className={`${menuCollapse ? 'ind-item-closed' : 'ind-item'}`}
                          onMouseEnter={() => setHovered(true)}
                          onMouseLeave={() => setHovered(false)}
                        >
                          <div className={`${menuCollapse ? 'i-closed' : 'i'}`}>
                            {menuCollapse ? (
                              <div className="padder">
                                <GiExitDoor className="icon-size" />
                                <span className="tooltip">Leaves</span>
                              </div>
                              // ''
                            ) : (
                              <div className="family"
                                style={{
                                  marginLeft: '20px'
                                }}>
                                <div className="bullet" style={{ backgroundColor: result == "leave" ? "#5757fe" : "gray" }}></div>
                                <span className="spa" style={{ marginLeft: '10px', color: result == "leave" ? "#5757fe" : "gray" }}>Leaves</span>
                              </div>
                            )}
                          </div>
                        </li>
                      </Link>
                    </RoleWiseModulWrapper>

                    <RoleWiseModulWrapper
                      user={user}
                      modules={modules}
                      features={features}
                      module={ModulesList?.Attendance}
                    >
                      <Link to="/attendance/empattendance" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                        <li className={`${menuCollapse ? 'ind-item-closed' : 'ind-item'} ${result === 'attendance' ? '' : ''}`}>
                          <div className={`${menuCollapse ? 'i-closed' : 'i'}`}>
                            {menuCollapse ? (
                              <div className="padder">
                                <HiMiniAdjustmentsVertical className="icon-size" />
                                <span className="tooltip">Attendance</span>
                              </div>
                              // ''
                            ) : (
                              <div className="family"
                                style={{
                                  marginLeft: '20px'
                                }}>
                                <div className="bullet" style={{ backgroundColor: result == "attendance" ? "#5757fe" : "gray" }}></div>
                                <span className="spa" style={{ marginLeft: '10px', color: result == "attendance" ? "#5757fe" : "gray" }}>Attendance</span>
                              </div>
                            )}
                          </div>
                        </li>
                      </Link>
                    </RoleWiseModulWrapper>

                    <RoleWiseModulWrapper
                      user={user}
                      modules={modules}
                      features={features}
                      module={ModulesList?.Holiday}
                    >
                      <Link to="/holiday" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                        <li
                          className={`${menuCollapse ? 'ind-item-closed' : 'ind-item'
                            } ${result === 'holiday' ? '' : ''}`}
                        >
                          <div className={`${menuCollapse ? 'i-closed' : 'i'}`}>
                            {menuCollapse ? (
                              <div className="padder">
                                <GiPalmTree className="icon-size" />
                                <span className="tooltip">Holiday</span>
                              </div>
                              // ''
                            ) : (
                              <div className="family"
                                style={{
                                  marginLeft: '20px'
                                }}>
                                <div className="bullet" style={{ backgroundColor: result == "holiday" ? "#5757fe" : "gray" }}></div>
                                <span className="spa" style={{ marginLeft: '10px', color: result == "holiday" ? "#5757fe" : "gray" }}>Holiday</span>
                              </div>
                            )}
                          </div>
                        </li>
                      </Link>
                    </RoleWiseModulWrapper>
                    <RoleWiseModulWrapper
                      user={user}
                      modules={modules}
                      features={features}
                      module={ModulesList?.Specialday}
                    >
                      <Link to="/specialday" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                        <li
                          className={`${menuCollapse ? 'ind-item-closed' : 'ind-item'
                            } ${result === 'specialday' ? '' : ''}`}
                        >
                          <div className={`${menuCollapse ? 'i-closed' : 'i'}`}>
                            {menuCollapse ? (
                              <div className="padder">
                                < GiFireworkRocket className="icon-size" />
                                <span className="tooltip">Special Day</span>
                              </div>
                              // ''
                            ) : (
                              <div className="family"
                                style={{
                                  marginLeft: '20px'
                                }}>
                                <div className="bullet" style={{ backgroundColor: result == "specialday" ? "#5757fe" : "gray" }}></div>
                                <span className="spa" style={{ marginLeft: '10px', color: result == "specialday" ? "#5757fe" : "gray" }}>Special Day</span>
                              </div>
                            )}
                          </div>
                        </li>
                      </Link>
                    </RoleWiseModulWrapper>

                    <RoleWiseModulWrapper
                      user={user}
                      modules={modules}
                      features={features}
                      module={ModulesList?.Appreciation}
                    >
                      <Link to="/appreciation" style={{ textDecoration: "inherit", color: "inherit" }}>
                        <li className={`${menuCollapse ? "ind-item-closed" : "ind-item"} ${(result === 'appreciation' || result == 'award') ? '' : ''}`}>
                          <div className={`${menuCollapse ? "i-closed" : "i"}`}>
                            {menuCollapse ? (
                              <div className="padder">
                                <FaHandsClapping className="icon-size" />
                                <span className="tooltip">Appreciation</span>
                              </div>
                              // ''
                            ) : (
                              <div className="family"
                                style={{
                                  marginLeft: '20px'
                                }}>
                                <div className="bullet" style={{ backgroundColor: (result == "appreciation" || result == "award") ? "#5757fe" : "gray" }}></div>
                                <span className="spa" style={{ marginLeft: '10px', color: (result == "appreciation" || result == "award") ? "#5757fe" : "gray" }}>Appreciation</span>
                              </div>
                            )}
                          </div>
                        </li>
                      </Link>
                    </RoleWiseModulWrapper>
                  </ul>
                </div>
              ) : null}

              <RoleWiseModulWrapper
                user={user}
                modules={modules}
                features={features}
                module={ModulesList?.Work}
              >
                <Link to="#" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                  <li
                    style={{
                      listStyle: 'none',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: menuCollapse ? 'center' : 'space-between',
                    }}
                    className={`${menuCollapse ? 'ind-item-closed' : 'ind-item'} ${(result === 'task' || result === 'project' || result == "timelogs")
                      ? 'active-block'
                      : ''
                      }`}
                    onClick={() => toggleDropdown('work')}
                  >
                    <div className={`${menuCollapse ? 'i-closed' : 'i'}`}>
                      <div className="padder">
                        {' '}
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <MdWork className="icon-size" />
                          {menuCollapse ? (
                            dropdownOpen.work
                          ) : (
                            <></>
                          )}
                        </div>
                        <span className="tooltip">Work</span>
                      </div>
                      {menuCollapse ? (
                        dropdownOpen.work
                      ) : (
                        <div
                          className="family"
                          style={{
                            display: 'flex',
                            width: '100%',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                          }}
                        >
                          <span className="spa">Work</span>
                          {dropdownOpen.work ? (
                            <FaChevronDown className="arrow-icon" style={{ marginLeft: '4px' }} />
                          ) : (
                            <FaChevronRight className="arrow-icon" style={{ marginLeft: '4px' }} />
                          )}
                        </div>
                      )}
                    </div>
                  </li>
                </Link>
              </RoleWiseModulWrapper>
              {dropdownOpen.work ? (
                <div className={`${menuCollapse ? 'collapsed-group' : ''}`} >
                  <ul className="sub-nav">
                    <RoleWiseModulWrapper
                      user={user}
                      modules={modules}
                      features={features}
                      module={ModulesList?.Project}
                    >
                      <Link to="/project/employeeproject" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                        <li className={`${menuCollapse ? 'ind-item-closed' : 'ind-item'} ${result === 'project' ? '' : ''}`}>
                          <div className={`${menuCollapse ? 'i-closed' : 'i'}`}>
                            {menuCollapse ? (
                              <div className="padder">
                                <GrProjects className="icon-size" />
                                <span className="tooltip">Project</span>
                              </div>
                              // ''
                            ) : (
                              <div className="family"
                                style={{
                                  marginLeft: '20px'
                                }}>
                                <div className="bullet" style={{ backgroundColor: result == "project" ? "#5757fe" : "gray" }}></div>
                                <span className="spa" style={{ marginLeft: '10px', color: result == "project" ? "#5757fe" : "gray" }}>Project</span>
                              </div>
                            )}
                          </div>
                        </li>
                      </Link>
                    </RoleWiseModulWrapper>

                    <RoleWiseModulWrapper
                      user={user}
                      modules={modules}
                      features={features}
                      module={ModulesList?.Task}
                    >
                      <Link to="/task/emptask" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                        <li
                          className={`${menuCollapse ? 'ind-item-closed' : 'ind-item'
                            } ${result === 'task' ? '' : ''}`}
                        >
                          <div className={`${menuCollapse ? 'i-closed' : 'i'}`}>
                            {menuCollapse ? (
                              <div className="padder">
                                <MdAssignmentTurnedIn className="icon-size" />
                                <span className="tooltip">Task</span>
                              </div>
                              // ''
                            ) : (
                              <div className="family"
                                style={{
                                  marginLeft: '20px'
                                }}>
                                <div className="bullet" style={{ backgroundColor: result == "task" ? "#5757fe" : "gray" }}></div>
                                <span className="spa" style={{ marginLeft: '10px', color: result == "task" ? "#5757fe" : "gray" }}>Task</span>
                              </div>
                            )}
                          </div>
                        </li>
                      </Link>
                    </RoleWiseModulWrapper>

                    <RoleWiseModulWrapper
                      user={user}
                      modules={modules}
                      features={features}
                      module={ModulesList?.TimeSheet}
                    >
                      <Link to="/timelogs" style={{ textDecoration: "inherit", color: "inherit" }}>
                        <li className={`${menuCollapse ? "ind-item-closed" : "ind-item"} ${result === 'timelogs' ? '' : ''}`}>
                          <div className={`${menuCollapse ? "i-closed" : "i"}`}>
                            {menuCollapse ? (
                              <div className="padder">
                                <FaClipboardList className="icon-size" />
                                <span className="tooltip">TimeSheet</span>
                              </div>
                              // ""
                            ) : (
                              <div className="family"
                                style={{
                                  marginLeft: '20px'
                                }}>
                                <div className="bullet" style={{ backgroundColor: result == "timelogs" ? "#5757fe" : "gray" }}></div>
                                <span className="spa" style={{ marginLeft: '10px', color: result == "timelogs" ? "#5757fe" : "gray" }}>TimeSheet</span>
                              </div>
                            )}
                          </div>
                        </li>
                      </Link>
                    </RoleWiseModulWrapper>
                  </ul>
                </div>
              ) : null}

              <RoleWiseModulWrapper
                user={user}
                modules={modules}
                features={features}
                module={ModulesList?.Invoices}
              >
                <Link to="#" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                  <li
                    className={`${menuCollapse ? 'ind-item-closed' : 'ind-item'} ${result === 'salesinvoices' || result === 'purchaseinvoices'
                      ? 'active-block'
                      : ''
                      }`}
                    onClick={() => toggleDropdown('invoices')}
                  >
                    <div className={`${menuCollapse ? 'i-closed' : 'i'}`}>
                      <div className="padder">
                        {' '}
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <FaFileInvoice className="icon-size" />
                          {menuCollapse ? (
                            dropdownOpen.invoices ? (
                              <FaChevronDown className="arrow-icon" style={{ marginLeft: '4px' }} />
                            ) : (
                              <FaChevronRight
                                className="arrow-icon"
                                style={{ marginLeft: '4px' }}
                              />
                            )
                          ) : (
                            <></>
                          )}
                        </div>
                        <span className="tooltip">Invoices</span>
                      </div>
                      {menuCollapse ? (
                        ''
                      ) : (
                        <div
                          className="family"
                          style={{
                            display: 'flex',
                            width: '100%',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                          }}
                        >
                          <span className="spa">Invoices</span>
                          {dropdownOpen.invoices ? (
                            <FaChevronDown className="arrow-icon" style={{ marginLeft: '4px' }} />
                          ) : (
                            <FaChevronRight className="arrow-icon" style={{ marginLeft: '4px' }} />
                          )}
                        </div>
                      )}
                    </div>
                  </li>
                </Link>
              </RoleWiseModulWrapper>
              {dropdownOpen.invoices ? (
                <ul className="sub-nav">
                  <RoleWiseModulWrapper
                    user={user}
                    modules={modules}
                    features={features}
                    module={ModulesList?.Salesinvoices}
                  >
                    <Link
                      to="/salesinvoices"
                      style={{ textDecoration: 'inherit', color: 'inherit' }}
                    >
                      <li
                        className={`${menuCollapse ? 'ind-item-closed sub-nav-item' : 'ind-item sub-nav-item'
                          } ${result === 'salesinvoices' ? 'active-block' : ''}`}
                      >
                        <div className={`${menuCollapse ? 'i-closed' : 'i'}`}>
                          <div className="padder">
                            {' '}
                            <img src={SalesInvoiceImg} className="icon-size" />
                            <span className="tooltip">Sales Invoices</span>
                          </div>
                          {menuCollapse ? (
                            ''
                          ) : (
                            <div className="family">
                              <span className="spa">Sales Invoices</span>
                            </div>
                          )}
                        </div>
                      </li>
                    </Link>
                  </RoleWiseModulWrapper>
                  <RoleWiseModulWrapper
                    user={user}
                    modules={modules}
                    features={features}
                    module={ModulesList?.Purchaseinvoices}
                  >
                    <Link
                      to="/purchaseinvoices"
                      style={{ textDecoration: 'inherit', color: 'inherit' }}
                    >
                      <li
                        className={`${menuCollapse ? 'ind-item-closed sub-nav-item' : 'ind-item sub-nav-item'
                          } ${result === 'purchaseinvoices' ? 'active-block' : ''}`}
                      >
                        <div className={`${menuCollapse ? 'i-closed' : 'i'}`}>
                          <div className="padder">
                            {' '}
                            <img src={PurchaseInvoiceImg} className="icon-size" />
                            <span className="tooltip">Purchase Invoices</span>
                          </div>
                          {menuCollapse ? (
                            ''
                          ) : (
                            <div className="family">
                              <span className="spa">Purchase Invoices</span>
                            </div>
                          )}
                        </div>
                      </li>
                    </Link>
                  </RoleWiseModulWrapper>
                </ul>
              ) : null}

              <RoleWiseModulWrapper
                user={user}
                modules={modules}
                features={features}
                module={ModulesList?.Transactions}
              >
                <Link to="/transaction" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                  <li
                    className={`${menuCollapse ? 'ind-item-closed' : 'ind-item'} 
                  ${result === 'transaction' ? 'active-block' : ''}`}
                  >
                    <div className={`${menuCollapse ? 'i-closed' : 'i'}`}>
                      <div className="padder">
                        <AiOutlineTransaction className="icon-size" />
                        <span className="tooltip">Transactions</span>
                      </div>
                      {menuCollapse ? (
                        ''
                      ) : (
                        <div className="family">
                          <span className="spa">Transactions</span>
                        </div>
                      )}
                    </div>
                  </li>
                </Link>
              </RoleWiseModulWrapper>

              <RoleWiseModulWrapper
                user={user}
                modules={modules}
                features={features}
                module={ModulesList?.Shareholders}
              >
                <Link to="/shareholder" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                  <li
                    className={`${menuCollapse ? 'ind-item-closed' : 'ind-item'} ${result === 'shareholder' ? 'active-block' : ''
                      }`}
                  >
                    <div className={`${menuCollapse ? 'i-closed' : 'i'}`}>
                      <div className="padder">
                        <FaSlideshare className="icon-size" />
                        <span className="tooltip">Share Holders</span>
                      </div>
                      {menuCollapse ? (
                        ''
                      ) : (
                        <div className="family">
                          <span className="spa">Share Holders</span>
                        </div>
                      )}
                    </div>
                  </li>
                </Link>
              </RoleWiseModulWrapper>

              <RoleWiseModulWrapper
                user={user}
                modules={modules}
                features={features}
                module={ModulesList?.Spends}
              >
                <Link to="/spends" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                  <li
                    className={`${menuCollapse ? 'ind-item-closed' : 'ind-item'} ${result === 'spends' ? 'active-block' : ''
                      }`}
                  >
                    <div className={`${menuCollapse ? 'i-closed' : 'i'}`}>
                      <div className="padder">
                        <GiExpense className="icon-size" />
                        <span className="tooltip">Spends</span>
                      </div>
                      {menuCollapse ? (
                        ''
                      ) : (
                        <div className="family">
                          <span className="spa">Spends</span>
                        </div>
                      )}
                    </div>
                  </li>
                </Link>
              </RoleWiseModulWrapper>

              <RoleWiseModulWrapper
                user={user}
                modules={modules}
                features={features}
                module={ModulesList?.Clients}
              >
                <Link to="/clients" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                  <li
                    className={`${menuCollapse ? 'ind-item-closed' : 'ind-item'} ${result === 'clients' ? 'active-block' : ''
                      }`}
                  >
                    <div className={`${menuCollapse ? 'i-closed' : 'i'}`}>
                      <div className="padder">
                        <FaUsers className="icon-size" />
                        <span className="tooltip">Clients</span>
                      </div>
                      {menuCollapse ? (
                        ''
                      ) : (
                        <div className="family">
                          <span className="spa">Clients</span>
                        </div>
                      )}
                    </div>
                  </li>
                </Link>
              </RoleWiseModulWrapper>

              <RoleWiseModulWrapper
                user={user}
                modules={modules}
                features={features}
                module={ModulesList?.Messages}
              >
                <Link to="/messages" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                  <li
                    className={`${menuCollapse ? 'ind-item-closed' : 'ind-item'} ${result === 'messages' ? 'active-block' : ''
                      }`}
                  >
                    <div className={`${menuCollapse ? 'i-closed' : 'i'}`}>
                      <div className="padder">
                        <TbMessages className="icon-size" />
                        <span className="tooltip">Messages</span>
                      </div>
                      {menuCollapse ? (
                        <div className="count-up">
                          <span className="message">{message.length}</span>
                        </div>
                      ) : (
                        <>
                          <div className="family">
                            <span className="spa">Messages</span>
                          </div>
                          <div className="count">
                            <span className="message">{message.length}</span>
                          </div>
                        </>
                      )}
                    </div>
                  </li>
                </Link>
              </RoleWiseModulWrapper>

              <RoleWiseModulWrapper
                user={user}
                modules={modules}
                features={features}
                module={ModulesList?.Report}
              >
                <Link to="#" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                  <li
                    style={{
                      listStyle: 'none',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: menuCollapse ? 'center' : 'space-between',
                    }}
                    className={`${menuCollapse ? 'ind-item-closed' : 'ind-item'} ${result === 'report'
                      ? 'active-block'
                      : ''
                      }`}
                    onClick={() =>
                      toggleDropdown('report')
                    }

                  >
                    <div className={`${menuCollapse ? 'i-closed' : 'i'}`}>
                      <div className="padder">
                        {' '}
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <TbReportSearch className="icon-size" />
                          {menuCollapse ? (
                            dropdownOpen.report
                          ) : (
                            <></>
                          )}
                        </div>
                        <span className="tooltip">Report</span>
                      </div>
                      {menuCollapse ? (
                        dropdownOpen.report
                      ) : (
                        <div
                          className="family"
                          style={{
                            display: 'flex',
                            width: '100%',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                          }}
                        >
                          <span className="spa">Report</span>
                          {dropdownOpen.report ? (
                            <FaChevronDown className="arrow-icon" style={{ marginLeft: '4px' }} />
                          ) : (
                            <FaChevronRight className="arrow-icon" style={{ marginLeft: '4px' }} />
                          )}
                        </div>
                      )}
                    </div>
                  </li>
                </Link>
              </RoleWiseModulWrapper>
              {dropdownOpen.report ? (
                <div className={`${menuCollapse ? 'collapsed-group' : ''}`} >
                  <ul className="sub-nav">
                    <RoleWiseModulWrapper
                      user={user}
                      modules={modules}
                      features={features}
                      module={ModulesList?.TaskReport}
                    >
                      <Link
                        to="/report/task"
                        style={{ textDecoration: 'inherit', color: 'inherit' }}
                      >
                        <li
                          className={`${menuCollapse ? 'ind-item-closed sub-nav-item' : 'ind-item sub-nav-item'
                            } ${result2 === 'task'
                              ? ''
                              : ''
                            }`}
                        >
                          <div className={`${menuCollapse ? 'i-closed' : 'i'}`}>
                            {menuCollapse ? (
                              <div className="padder">
                                <AiOutlineFileDone className="icon-size" />
                                {' '}
                                <span className="tooltip">Task Report</span>
                              </div>
                              // ''
                            ) : (
                              <div className="family"
                                style={{
                                  marginLeft: '20px'
                                }}>
                                <div className="bullet" style={{ backgroundColor: result2 == "task" ? "#5757fe" : "gray" }}></div>
                                <span className="spa" style={{ marginLeft: '10px', color: result2 == "task" ? "#5757fe" : "gray" }}>Task Report</span>
                              </div>
                            )}
                          </div>
                        </li>
                      </Link>
                    </RoleWiseModulWrapper>
                    <RoleWiseModulWrapper
                      user={user}
                      modules={modules}
                      features={features}
                      module={ModulesList?.AttendanceReport}
                    >
                      <Link
                        to="/report/attendance"
                        style={{ textDecoration: 'inherit', color: 'inherit' }}
                      >
                        <li
                          className={`${menuCollapse ? 'ind-item-closed sub-nav-item' : 'ind-item sub-nav-item'
                            } ${result2 === 'attendance'
                              ? ''
                              : ''
                            }`}

                        >
                          <div className={`${menuCollapse ? 'i-closed' : 'i'}`}>
                            {menuCollapse ? (
                              <div className="padder">
                                <AiOutlineClockCircle className="icon-size" />
                                {' '}
                                <span className="tooltip">Attendance Report</span>
                              </div>
                              // ''
                            ) : (
                              <div className="family"
                                style={{
                                  marginLeft: '20px'
                                }}>
                                <div className="bullet" style={{ backgroundColor: result2 == "attendance" ? "#5757fe" : "gray" }}></div>
                                <span className="spa" style={{ marginLeft: '10px', color: result2 == "attendance" ? "#5757fe" : "gray" }}>Attendance Report</span>
                              </div>
                            )}
                          </div>
                        </li>
                      </Link>
                    </RoleWiseModulWrapper>
                  </ul>
                </div>
              ) : null}

              <RoleWiseModulWrapper
                user={user}
                modules={modules}
                features={features}
                module={ModulesList?.Department}
              >
                <Link to="/department" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                  <li
                    className={`${menuCollapse ? 'ind-item-closed' : 'ind-item'
                      } ${result?.includes('department') ? 'active-block' : ''}`}
                  >
                    <div className={`${menuCollapse ? 'i-closed' : 'i'}`}>
                      <div className="padder">
                        <MdGroups className="icon-size" />
                        <span className="tooltip">Department</span>
                      </div>
                      {menuCollapse ? (
                        ''
                      ) : (
                        <div className="family">
                          <span className="spa">Department</span>
                        </div>
                      )}
                    </div>
                  </li>
                </Link>
              </RoleWiseModulWrapper>

              <RoleWiseModulWrapper
                user={user}
                modules={modules}
                features={features}
                module={ModulesList?.Designation}
              >
                <Link to="/designation" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                  <li
                    className={`${menuCollapse ? 'ind-item-closed' : 'ind-item'
                      } ${result === 'designation' ? 'active-block' : ''}`}
                  >
                    <div className={`${menuCollapse ? 'i-closed' : 'i'}`}>
                      <div className="padder">
                        <FaSitemap className="icon-size" />
                        <span className="tooltip">Designation</span>
                      </div>
                      {menuCollapse ? (
                        ''
                      ) : (
                        <div className="family">
                          <span className="spa">Designation</span>
                        </div>
                      )}
                    </div>
                  </li>
                </Link>
              </RoleWiseModulWrapper>

              {/* <RoleWiseModulWrapper
                user={user}
                modules={modules}
                features={features}
                module={ModulesList?.Ticket}
              >
                <Link to="/ticket" style={{ textDecoration: "inherit", color: "inherit" }}>
                  <li className={`${menuCollapse ? "ind-item-closed" : "ind-item"} ${result === 'ticket' ? 'active-block' : ''}`}>
                    <div className={`${menuCollapse ? "i-closed" : "i"}`}>
                      <div className="padder">
                        <SlEarphonesAlt className="icon-size" />
                        <span className="tooltip">Ticket</span>
                      </div>
                      {menuCollapse ? (
                        ""
                      ) : (
                        <div className="family">
                          <span className="spa">Ticket</span>
                        </div>
                      )}
                    </div>
                  </li>
                </Link>
              </RoleWiseModulWrapper> */}

              <RoleWiseModulWrapper
                user={user}
                modules={modules}
                features={features}
                module={ModulesList?.Notice}
              >
                <Link to="/notice" style={{ textDecoration: "inherit", color: "inherit" }}>
                  <li className={`${menuCollapse ? "ind-item-closed" : "ind-item"} ${result === 'notice' ? 'active-block' : ''}`}>
                    <div className={`${menuCollapse ? "i-closed" : "i"}`}>
                      <div className="padder">
                        <FaClipboard className="icon-size" />
                        <span className="tooltip">Notice</span>
                      </div>
                      {menuCollapse ? (
                        ""
                      ) : (
                        <div className="family">
                          <span className="spa">Notice</span>
                        </div>
                      )}
                    </div>
                  </li>
                </Link>
              </RoleWiseModulWrapper>

              <RoleWiseModulWrapper
                user={user}
                modules={modules}
                features={features}
                module={ModulesList?.Documents}
              >
                <Link to="/document/empdocument" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                  <li className={`${menuCollapse ? 'ind-item-closed' : 'ind-item'} ${result === 'document' ? 'active-block' : ''}`}>
                    <div className={`${menuCollapse ? 'i-closed' : 'i'}`}>
                      <div className="padder">
                        <IoMdDocument className="icon-size" />
                        <span className="tooltip">Documents</span>
                      </div>
                      {menuCollapse ? null : (
                        <div className="family">
                          <span className="spa">Documents</span>
                        </div>
                      )}
                    </div>
                  </li>
                </Link>
              </RoleWiseModulWrapper>

              <RoleWiseModulWrapper
                user={user}
                modules={modules}
                features={features}
                module={ModulesList?.Salary}
              >
                <Link to="/salary/empsalary" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                  <li className={`${menuCollapse ? 'ind-item-closed' : 'ind-item'} ${result === 'salary' ? 'active-block' : ''}`}>
                    <div className={`${menuCollapse ? 'i-closed' : 'i'}`}>
                      <div className="padder">
                        <GiTakeMyMoney className="icon-size" />
                        <span className="tooltip">Salary</span>
                      </div>
                      {menuCollapse ? null : (
                        <div className="family">
                          <span className="spa">Salary</span>
                        </div>
                      )}
                    </div>
                  </li>
                </Link>
              </RoleWiseModulWrapper>

              <RoleWiseModulWrapper
                user={user}
                modules={modules}
                features={features}
                module={ModulesList?.Reminders}
              >
                <Link to="/reminder" style={{ textDecoration: "inherit", color: "inherit" }}>
                  <li className={`${menuCollapse ? "ind-item-closed" : "ind-item"} ${result === 'reminder' ? 'active-block' : ''}`}>
                    <div className={`${menuCollapse ? "i-closed" : "i"}`}>
                      <div className="padder">
                        <FaBell className="icon-size" />
                        <span className="tooltip">Reminder</span>
                      </div>
                      {menuCollapse ? (
                        ''
                      ) : (
                        <div className="family">
                          <span className="spa">Reminder</span>
                        </div>
                      )}
                    </div>
                  </li>
                </Link>
              </RoleWiseModulWrapper>

              <RoleWiseModulWrapper
                user={user}
                modules={modules}
                features={features}
                module={ModulesList?.WaterJug}
              >
                <Link to="/waterjug" style={{ textDecoration: "inherit", color: "inherit" }}>
                  <li className={`${menuCollapse ? "ind-item-closed" : "ind-item"} ${result === 'waterjug' ? 'active-block' : ''}`}>
                    <div className={`${menuCollapse ? "i-closed" : "i"}`}>
                      <div className="padder">
                        <FaBottleWater className="icon-size" />
                        <span className="tooltip">Water Jug</span>
                      </div>
                      {menuCollapse ? (
                        ''
                      ) : (
                        <div className="family">
                          <span className="spa">Water Jug</span>
                        </div>
                      )}
                    </div>
                  </li>
                </Link>
              </RoleWiseModulWrapper>

              <RoleWiseModulWrapper
                user={user}
                modules={modules}
                features={features}
                module={ModulesList?.Settings}
              >
                <Link to="/setting" style={{ textDecoration: "inherit", color: "inherit" }}>
                  <li className={`${menuCollapse ? "ind-item-closed" : "ind-item"} ${result === 'setting' ? 'active-block' : ''}`}>
                    <div className={`${menuCollapse ? "i-closed" : "i"}`}>
                      <div className="padder">
                        <IoSettingsSharp className="icon-size" />
                        <span className="tooltip">Settings</span>
                      </div>
                      {menuCollapse ? (
                        ''
                      ) : (
                        <div className="family">
                          <span className="spa">Settings</span>
                        </div>
                      )}
                    </div>
                  </li>
                </Link>
              </RoleWiseModulWrapper>

            </ul>
          </div>
        </div>
      </div>
      <div className="body-overlay"></div>
    </>
  );
};

export default Sidebar;
